


























import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { commonModalNames } from '@/components/common/constants';

export default {
  name: 'HeaderGuest',
  components: {
    BravadoButtonV3,
  },
  data() {
    return { commonModalNames };
  },
  methods: {
    handleLoginClick(): void {
      // @ts-ignore
      this.$analytics.logEvent('war-room__header__login-link__click');
      // @ts-ignore
      this.$modal.showWithRoute('SIGN_IN_MODAL');
    },
    handleSignUpClick(): void {
      // @ts-ignore
      this.$analytics.logEvent('war-room__header__signup-button__click');
      // @ts-ignore
      this.$modal.showWithRoute('WAR_ROOM_SIGN_UP_MODAL');
    },
  },
};
